export default "__VITE_ASSET__DCTA_kzT__"